module.exports = __webpack_public_path__ + "img/ranking-1.59ff7c4c.svg";